import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ typographyPresets, colors, fontColors }) => ({
    entryRow: {
        minHeight: '104px',
        borderRadius: '2px 10px 10px 10px',
        backgroundColor: '#f0f2f51a',
        marginBottom: '16px',
        marginRight: 16,
        paddingLeft: 16,
        display: 'flex',
        position: 'relative',
    },
    entry: {
        ...typographyPresets.titleSmallBold,
        wordBreak: 'break-word',
        paddingTop: '16px',
        color: colors.white,
        paddingRight: 32,
    },
    entryAuthor: {
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        paddingTop: '16px',
        paddingBottom: '8px',
    },
    entryName: {
        ...typographyPresets.bodyTertiary,
        textTransform: 'none',
        color: colors.light.grey,
    },
    upvote: {
        backgroundColor: colors.light.offWhite1,
        width: '40px',
        height: '52px',
        borderRadius: '6px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        position: 'absolute',
        right: -16,
    },
    upvoteBtn: {
        padding: '0',
        width: '100%',
        fontSize: '0.875rem',
        borderRadius: '6px 6px 0 0',
        border: 0,

        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
    },
    upVoteBlue: {
        color: colors.brand.blue,
    },
    upVoteGrey: {
        color: colors.light.grey,
    },
    voteCount: {
        ...typographyPresets.bodyTertiary,
        textAlign: 'center',
        color: fontColors.darkGrey,
    },
}))
